// JavaScript Document
//components/signs/category/Table.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

const useStyles = makeStyles({
  table: {
	maxHeight:254,
	  flexGrow: 1,
	//maxHeight: '100%'
  },
	datecol : {
		minWidth: 100
	}

});


export default function UpdateDetails(props) {
	const classes = useStyles();
	const {items} = props;

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="sign categories">
        <TableHead>
          <TableRow>
	  		    <TableCell>Date</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Seconds</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow hover role="checkbox" key={row.id}>
              <TableCell component="th" scope="row" className={classes.datecol}>
                {moment(row.date+" "+row.time).fromNow()}
              </TableCell>
	  			    <TableCell>{row.log_type}</TableCell>
              <TableCell>{row.description}</TableCell>
              <TableCell>{row.duration}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
